import React from 'react';

const ListLanguageFolder = () => {
  return <></>;
};

export default ListLanguageFolder;
